<template>
  <div class="text text-accessibility" id="skipTo">
    <div v-html="getTextAccessibility"></div>
    <router-link :to="{ name: 'chapter'}">zurück zur Check-App</router-link>
  </div>
</template>

<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'accessibility',

  computed: {
    ...mapGetters([
      'getTextAccessibility'
    ]),
  }
}
</script>